
import { CompanyDetails } from "../../types/quotation";

/**
 * Retrieves company details from various localStorage sources
 * Uses a fallback strategy to ensure complete company information
 */
export const getCompanyDetailsFromStorage = (): CompanyDetails => {
  console.log("Getting company details from storage");
  
  // Log the current state of localStorage
  console.log("Current localStorage state:", {
    formData: localStorage.getItem('formData'),
    companyInfo: localStorage.getItem('companyInfo'),
    companyDetails: localStorage.getItem('companyDetails')
  });
  
  // Get company details from step one - directly check the formData first
  let formData = null;
  let companyDetails: CompanyDetails = {};
  
  try {
    const formDataStr = localStorage.getItem('formData');
    if (formDataStr) {
      formData = JSON.parse(formDataStr);
      console.log("Directly loaded formData:", formData);
      
      // Use the form data directly as company details
      if (formData && typeof formData === 'object') {
        companyDetails = {
          companyName: formData.companyName || "",
          brandName: formData.brandName || "",
          personInCharge: formData.personInCharge || "",
          jobTitle: formData.jobTitle || "",
          email: formData.email || "",
          mobile: formData.mobile || ""
        };
        console.log("Using form data directly for company details:", companyDetails);
      }
    }
  } catch (e) {
    console.error("Error parsing form data:", e);
  }
  
  // If we couldn't get companyDetails directly, try other sources
  if (!companyDetails.companyName) {
    // Try alternative sources only if direct form data failed
    const companyInfoSources = [
      localStorage.getItem('companyInfo'),
      localStorage.getItem('companyDetails')
    ];
    
    // Use the first non-empty source
    for (const source of companyInfoSources) {
      if (source) {
        try {
          const parsed = JSON.parse(source);
          if (parsed && Object.keys(parsed).length > 0) {
            companyDetails = parsed;
            console.log("Retrieved company details from storage source:", companyDetails);
            break;
          }
        } catch (e) {
          console.error("Error parsing source:", e);
        }
      }
    }
  }
  
  // Only use default values if we still don't have the data
  if (!companyDetails.companyName) {
    console.warn("No company details found in any storage, using empty defaults");
    companyDetails = {
      companyName: "",
      brandName: "",
      personInCharge: "",
      jobTitle: "",
      email: "",
      mobile: ""
    };
  }
  
  return companyDetails;
};

/**
 * Saves company details to localStorage for persistence
 */
export const saveCompanyDetailsToStorage = (companyDetails: CompanyDetails): void => {
  localStorage.setItem('companyDetails', JSON.stringify(companyDetails));
  console.log("Saved company details to storage:", companyDetails);
};
